import React from 'react'
import styles from './Footer.css'

export default function Footer () {
  return <div className={styles.footer}>Made for Danni by Oli</div>
}
